export function safeCaptureStream(
  el: HTMLCanvasElement,
  frameRequestRate = 24
) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const captureStream = el.captureStream || (el as any).mozCaptureStream;

  if (!captureStream) {
    throw new Error("captureStream is not supported!");
  }

  // call getContext in order to fix bug in firefox
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1572422
  el.getContext("2d");

  return el.captureStream(frameRequestRate);
}
